export enum PathEnum {
  PAGES = '/pages',
  LOGIN = '/login',
  HOME = '/home',
  PROFILE = '/profile',
  LOGOUT = '', //non c'è una page di logout
  RECOVER_PASSWORD = '/recover-password',
  FIGLI = '/children',
  PORTAFOGLIO = '/portafoglio',
  CALENDARIO = '/calendario',
  MENU = '/menu',
  RICARICHE = '/ricariche',
  VERIFY_ACCOUNT = '/verify-account',
  ENABLE_ACCOUNT = '/enable-account',
  PRATICHE = '/pratiche',
  PRATICA = '/pratica',
  STATO_PRATICA = '/stato-pratica',
  DETTAGLIO_PRATICA = '/dettaglio-pratica',
  SELEZIONE_COMUNE = '/selezione-comune',
  AUTH_CALLBACK = '/auth/callback',
  AUTH_ERROR = '/auth/error',
  CONTATTI = '/contatti',
}

export enum IconMenuEnum {
  LOGIN = 'log-in-outline',
  HOME = 'home-outline',
  PROFILE = 'person-circle-outline',
  LOGOUT = 'log-out-outline',
  FIGLI = 'people-outline',
  PORTAFOGLIO = 'wallet-outline',
  CALENDARIO = 'calendar-outline',
  MENU = 'document-text-outline',
  RICARICHE = 'card-outline',
  PRATICHE = 'clipboard-outline',
  STATO_PRATICA = 'document-attach-outline',
  SELEZIONE_COMUNE = 'swap-horizontal-outline',
  CONTATTI = 'mail-outline',
}

export enum LabelMenuEnum {
  LOGIN = 'ACCEDI',
  HOME = 'HOME',
  PROFILE = '',
  LOGOUT = 'LOG OUT',
  FIGLI = 'PROFILO STUDENTE',
  PORTAFOGLIO = 'PORTAFOGLIO',
  CALENDARIO = 'CALENDARIO',
  MENU = 'MENU',
  PAGAMENTI = 'PAGAMENTI',
  PRATICHE = 'NUOVA PRATICA',
  STATO_PRATICA = 'LE MIE PRATICHE',
  CAMBIA_COMUNE = 'CAMBIA COMUNE',
  SELEZIONA_COMUNE = 'SELEZIONA COMUNE',
  CONTATTI = 'CONTATTI',
}


export enum RoutesEnum {
  PAGES = 'pages',
  LOGIN = 'login',
  HOME = 'home',
  PROFILE = 'profile',
  RECOVER_PASSWORD = 'recover-password',
  PROFILO = 'profile',
  FIGLI = 'children',
  PORTAFOGLIO = 'portafoglio',
  CALENDARIO = 'calendario',
  MENU = 'menu',
  RICARICHE = 'ricariche',
  VERIFY_ACCOUNT = 'verify-account',
  ENABLE_ACCOUNT = 'enable-account',
  GUIDA_RENDICONTAZIONE = 'guida-pagopa',
  PRATICHE = 'pratiche',
  PRATICA = 'pratica',
  STATO_PRATICA = 'stato-pratica',
  DETTAGLIO_PRATICA = 'dettaglio-pratica',
  SELEZIONE_COMUNE = 'selezione-comune',
  AUTH_CALLBACK = 'auth/callback',
  AUTH_ERROR = 'auth/error',
  CONTATTI = 'contatti',
}


